const currentYear = new Date().getFullYear()

export const getDays = placeholderText => {
  const days = [...Array(31).keys()].map(day => ({
    value: day + 1,
    text: `${day + 1}`.padStart(2, '0'),
  }))

  days.unshift({
    value: '',
    text: placeholderText,
    disabled: true,
  })

  return days
}

export const getMonths = placeholderText => {
  const months = [...Array(12).keys()].map(month => ({
    value: month + 1,
    text: `${month + 1}`.padStart(2, '0'),
  }))

  months.unshift({
    value: '',
    text: placeholderText,
    disabled: true,
  })

  return months
}

/**
 *
 * @param {number} minAge
 * @param {string} placeholderText
 * @param {Array<{value: string | number, text: string, disabled: boolean}>} customYears
 * @returns
 */
export const getYears = (
  minAge,
  placeholderText,
  {
    enabledYears = null,
    range = { startYear: currentYear - 120, endYear: currentYear },
  }
) => {
  if (range.endYear < range.startYear) {
    throw new Error('endYear must be greater than startYear')
  }

  let yearsCount = range.endYear - range.startYear
  // To get the correct count that will also show the startYear
  yearsCount = yearsCount + range.endYear - currentYear - 1 - minAge

  const years = [...Array(yearsCount).keys()].map(index => {
    const year = range.endYear - index - minAge
    let disabled = false

    if (enabledYears && enabledYears.length) {
      disabled = !enabledYears.includes(year)
    }

    return {
      value: year,
      text: `${year}`,
      disabled,
    }
  })

  years.unshift({
    value: '',
    text: placeholderText,
    disabled: true,
  })

  return years
}
